import { render, staticRenderFns } from "./Dividend.vue?vue&type=template&id=1f34f601&scoped=true&"
import script from "./Dividend.vue?vue&type=script&lang=js&"
export * from "./Dividend.vue?vue&type=script&lang=js&"
import style0 from "./Dividend.vue?vue&type=style&index=0&id=1f34f601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34f601",
  null
  
)

export default component.exports